import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fields", "template", "existingField", "newLabel", "newInput"]

  addField() {
    const count = this.existingFieldTargets.length;
    let content = this.templateTarget.content.cloneNode(true)
    const wrapper = content.querySelector('#location_field')
    const label = wrapper.querySelector('[data-locations-target="newLabel"]')
    const input = wrapper.querySelector('[data-locations-target="newInput"]')
    if (label && input) {
      const newId = `company_details_locations_${count}`
      label.setAttribute('for', newId)
      input.setAttribute('id', newId)
    }
    this.fieldsTarget.appendChild(content)
  }

  removeField(event) {
    event.target.closest('#location_field').remove()
  }
}
